// Widget Settings Component
// Chat widget customization (title, bubble text, greeting)

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { MessageCircle } from 'lucide-react';

const WidgetSettings = ({ widgetTitle, chatBubbleText, widgetGreeting, onChange }) => {
  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <MessageCircle className="w-5 h-5 text-teal-500" />
          Widget Settings
        </CardTitle>
        <CardDescription>
          Customize the chat widget appearance and messages
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="widget_title">Widget Title</Label>
          <Input
            id="widget_title"
            value={widgetTitle}
            onChange={(e) => onChange('widget_title', e.target.value)}
            placeholder="Your Firm Name"
            className="mt-1"
            data-testid="widget-title-input"
          />
          <p className="text-xs text-slate-500 mt-1">Shown in the widget header</p>
        </div>
        
        <div>
          <Label htmlFor="chat_bubble_text">Chat Bubble Text</Label>
          <Input
            id="chat_bubble_text"
            value={chatBubbleText}
            onChange={(e) => onChange('chat_bubble_text', e.target.value)}
            placeholder="Injured? Get Help Now - It's Free"
            className="mt-1"
            data-testid="chat-bubble-text-input"
          />
          <p className="text-xs text-slate-500 mt-1">Call-to-action text shown above the chat button</p>
        </div>
        
        <div>
          <Label htmlFor="widget_greeting">Greeting Message</Label>
          <Textarea
            id="widget_greeting"
            value={widgetGreeting}
            onChange={(e) => onChange('widget_greeting', e.target.value)}
            placeholder="Hi! I'm here to help you get started with your case..."
            className="mt-1"
            rows={3}
            data-testid="widget-greeting-input"
          />
          <p className="text-xs text-slate-500 mt-1">First message clients see</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default WidgetSettings;
